import(/* webpackMode: "eager" */ "/wagfwafwaefw/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/wagfwafwaefw/components/sentry-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/wagfwafwaefw/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/wagfwafwaefw/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/wagfwafwaefw/components/ui/tooltip.tsx");
